<template>
  <div class="relative slides">
    <hooper
      style="height: auto"
      ref="carousel"
      :wheelControl="false"
      infiniteScroll
      @slide="updateCarousel"
      v-if="items.length"
    >
      <slide
        v-for="({ img_desktop, img_mobile, link, target }, keySlide) in items"
        :key="keySlide"
      >
        <a v-if="link" :href="link" :target="target ? '_blank' : '_self'">
          <img
            :src="files + (xs && img_mobile ? img_mobile : img_desktop)"
            class="d-block item-img"
            width="100%"
          />
        </a>

        <img
          v-else
          :src="files + (xs && img_mobile ? img_mobile : img_desktop)"
          class="d-block item-img"
          width="100%"
        />
      </slide>
    </hooper>

    <div class="d-flex justify-space-between px-3 px-md-4 px-lg-5 slides-nav">
      <a
        class="d-flex align-center justify-center elevation-2 pr-1 nav-item"
        @click.prevent="slidePrev"
      >
        <v-icon color="primary" :size="xs ? 20 : 30"> fa-angle-left </v-icon>
      </a>
      <a
        class="d-flex align-center justify-center elevation-2 pl-1 nav-item"
        @click.prevent="slideNext"
      >
        <v-icon color="primary" :size="xs ? 20 : 30"> fa-angle-right </v-icon>
      </a>
    </div>
  </div>
</template>

<script>
import { Hooper, Slide } from "hooper";
import "hooper/dist/hooper.css";

const _config = {
  mod: "slides",
};

export default {
  data: () => ({
    carouselData: 0,
  }),
  computed: {
    items() {
      return this.$rest(_config.mod).list;
    },
    xs() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  mounted() {
    this.$rest("slides").get();

    // Fix for iOS Safari - ensure carousel initializes properly
    if (/iPhone|iPad|iPod/.test(navigator.userAgent)) {
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.$refs.carousel && this.$refs.carousel.$el) {
            this.$refs.carousel.$el.dispatchEvent(new Event("resize"));
          }
        }, 100);
      });
    }
  },
  methods: {
    slidePrev() {
      this.$refs.carousel.slidePrev();
    },
    slideNext() {
      this.$refs.carousel.slideNext();
    },
    updateCarousel(payload) {
      this.myCarouselData = payload.currentSlide;
    },
  },
  watch: {
    carouselData() {
      this.$refs.carousel.slideTo(this.carouselData);
    },
  },
  components: {
    Hooper,
    Slide,
  },
};
</script>

<style lang="scss" scoped>
.slides {
  aspect-ratio: 1920 / 680;
  position: relative;
  overflow: hidden;
  width: 100%;
  @media screen and (max-width: 600px) {
    aspect-ratio: 600 / 600;
  }
  @supports not (aspect-ratio: 1) {
    min-height: 400px;
    @media screen and (max-width: 600px) {
      min-height: 300px;
    }
  }
  .item-img {
    aspect-ratio: 1920 / 680;
    object-fit: cover;
    -o-object-fit: cover;
    width: 100%;
    height: 100%;
    display: block;
    @media screen and (max-width: 600px) {
      aspect-ratio: 600 / 600;
    }
  }
  .slides-nav {
    height: 0;
    left: 0;
    margin-top: -25px;
    position: absolute;
    top: 50%;
    width: 100%;
    z-index: 10;
    @media screen and (max-width: 600px) {
      margin-top: -20px;
    }
    .nav-item {
      background-color: #ffffff;
      border-radius: 50%;
      height: 50px;
      width: 50px;
      cursor: pointer;
      transition: all 0.2s ease;
      @media screen and (max-width: 600px) {
        height: 40px;
        width: 40px;
      }
      &:hover {
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
      }
    }
  }
}
</style>

<style lang="scss">
.hooper-track {
  padding: 0 !important;
  width: 100% !important;
}

.hooper-container {
  width: 100% !important;
  height: 100% !important;
}

.hooper-slide {
  width: 100% !important;
  height: 100% !important;
}

.hooper {
  width: 100% !important;
  height: 100% !important;
}
</style>
